import React from 'react';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Item, ConfigItems } from './styles';
import ConfigBox from './ConfigBox';
import {
  makhsanGetSystemConfigs,
  SystemConfigView,
  ISystemConfigViews,
  makhsanGetSystemConfigsFn,
} from 'store/makhsanSystemConfig/makhsanSystemConfigSlice';
import { appDispatch, RootState } from 'store/store';

interface IStateToProps {
  systemConfigs: ISystemConfigViews;
}

interface IOwnProps {}

interface DispatchToProps {
  makhsanGetSystemConfigs: () => ReturnType<typeof makhsanGetSystemConfigsFn>;
}
interface IComponentState {
  loading: boolean;
  selectedConfigId?: number;
}
type IComponentProps = IStateToProps & IOwnProps & DispatchToProps;

class ConfigManager extends React.PureComponent<
  IComponentProps,
  IComponentState
> {
  state: IComponentState = {
    loading: false,
    selectedConfigId: undefined,
  };

  componentDidMount(): void {
    this.props.makhsanGetSystemConfigs().then(
      () => {
        this.setState({ loading: false });
      },
      () => {
        this.setState({ loading: false });
      }
    );
  }

  selectConfig = (key: number) => {
    this.setState({ selectedConfigId: key });
  };

  render() {
    const { selectedConfigId } = this.state;
    const { systemConfigs } = this.props;
    const selectedConfig = selectedConfigId && systemConfigs[selectedConfigId];
    return (
      <div>
        <div style={{ display: 'flex' }}>
          <ConfigItems helve={!!selectedConfig}>
            {Object.values(systemConfigs).map((config: SystemConfigView) => {
              return (
                <Item
                  className="row"
                  isActive={config.name === selectedConfigId}
                  key={config.id}
                  onClick={() => this.selectConfig(config.id!)}
                >
                  <div className="col s12 m4" style={{ overflow: 'hidden' }}>
                    {config.name}
                  </div>
                  <div className="col s12 m8" style={{ overflow: 'hidden' }}>
                    {config.value || '-'}
                  </div>
                </Item>
              );
            })}
          </ConfigItems>
          {selectedConfig && <ConfigBox config={selectedConfig} />}
        </div>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state
) => {
  const systemConfigs = state.makhsanSystemConfig;
  return { systemConfigs };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchToProps,
  IOwnProps
> = () => {
  return {
    makhsanGetSystemConfigs: () => {
      return appDispatch(makhsanGetSystemConfigs({}));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigManager);
